import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { 
    fetchPoll,
    fetchResults,
    fetchVotes,
    registerVote
} from '../../actions/pollActions'; 

import Poll from './poll';

const mapStateToProps = (state, ownProps) => {
    return {
        poll: state.app.poll,
        pollVotes: state.entities.pollVotes,
        pollResults: state.entities.pollResults,
        inlineParentMetadata: state.inline.parentMetadata,
        appType: state.app.appType
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchPoll: (pollId) => dispatch(fetchPoll(pollId)),
        fetchResults: (pollId) => dispatch(fetchResults(pollId)),
        fetchVotes: (pollId) => dispatch(fetchVotes(pollId)),
        registerVote: (pollOptionId) => dispatch(registerVote(pollOptionId)),
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Poll));